export default {
  isLoggedIn(state) {
    if (state.profile && state.profile.auth_uid && state.profile.login)
      return true
    else return false
  },
  cancellationReasonsPartial(state) {
    if (
      state.companie.settings &&
      state.companie.settings.cancellationReasonsPartial
    )
      return state.companie.settings.cancellationReasonsPartial
    else return null
  },
  cancellationReasonsPartialDesc: (state) => (id) => {
    // Retorna descricao da razao ou próprio id
    let reasons = state.companie.settings.cancellationReasonsPartial
    let desc = id ? reasons.find((reason) => reason.id === id) : undefined
    return desc ? desc.description : id
  },
  cancellationReasons(state) {
    if (state.companie.settings && state.companie.settings.cancellationReasons)
      return state.companie.settings.cancellationReasons
    else return null
  },
  cancellationReasonsDesc: (state) => (id) => {
    // Retorna descricao da razao ou próprio id
    if (id === 'system') return 'Cancelamento automático'
    let reasons = state.companie.settings.cancellationReasons
    let desc = id ? reasons.find((reason) => reason.id === id) : undefined
    return desc ? desc.description : id
  },
  withPartialReasons: (state) => (invoice, partialItemsDesc = '') => {
    if (invoice.status === 'with_partial') {
      Object.values(invoice.items).forEach((item) => {
        if (item.partial === true) {
          if (partialItemsDesc === '') {
            partialItemsDesc += `${item.partial_desc}`;
          } else {
            partialItemsDesc += `; ${item.partial_desc}`;
          }
        }
      });
      return partialItemsDesc
    } else {
      return 'np'
    }
  },
  withPartialReasonsConcat: (state) => (invoice, partialItemsDesc = '') => {
    if (invoice.status === 'with_partial') {
      Object.values(invoice.items).forEach((item) => {
        if (item.partial === true) {
          if (partialItemsDesc === '') {
            partialItemsDesc += `${item.partial_desc} (${item.product} - Qtd: ${item.partial_quantity !== undefined && item.partial_quantity !== null ? item.partial_quantity : '-'})`;
          } else {
            partialItemsDesc += `; ${item.partial_desc} (${item.product} - Qtd: ${item.partial_quantity !== undefined && item.partial_quantity !== null ? item.partial_quantity : '-'})`;
          }
        }
      });
      return partialItemsDesc
    } else {
      return 'np'
    }
  },
  // Cliente com ao menos uma nota em entrega parcial
  customerHasPartial: () => (customer) => {
    if (customer.has_invoice_partial) return true
    return Object.values(customer.invoices || {}).some((invoice) => invoice.status === 'with_partial')
  },
  // Motivo exibido para o cliente nos relatórios. Em entrega parcial o cliente não recebe motivo,
  // o detalhe está nos itens da nota, então indica em qual coluna consultar
  customerReasonDesc: (state, getters) => (customer, itemsColumnName = 'Status Motivo documento') => {
    if (customer.canceled_reason) return getters.cancellationReasonsDesc(customer.canceled_reason)
    if (getters.customerHasPartial(customer)) return `Entrega com observação nos itens, ver coluna "${itemsColumnName}"`
    return ''
  },
  // Problemas por documento do cliente: itens e quantidades em entrega parcial e motivo de notas canceladas
  // Ex.: "Doc 180122: Avaria (PRODUTO - Qtd: 3) | Doc 180123: Cancelada - Recusa (obs)"
  customerInvoicesProblemsConcat: (state, getters) => (customer) => {
    const problems = []
    Object.values(customer.invoices || {}).forEach((invoice) => {
      const doc = invoice.invoice || invoice.order_number || ''
      if (invoice.status === 'with_partial') {
        problems.push(`Doc ${doc}: ${getters.withPartialReasonsConcat(invoice)}`)
      } else if (invoice.cancel_reason) {
        let text = `Doc ${doc}: Cancelada - ${getters.cancellationReasonsDesc(invoice.cancel_reason)}`
        if (invoice.cancel_notice) text += ` (${invoice.cancel_notice})`
        problems.push(text)
      }
    })
    return problems.join(' | ')
  },
  getCustomerCommentsConcat: (state) => (customer, returntext = '') => {
    if (Array.isArray(customer.comments) && customer.comments.length > 0) {
      customer.comments.forEach((item) => {
        if (item.comment) {
          if (returntext === '') {
            returntext += `${item.comment}`;
          } else {
            returntext += `|${item.comment}`;
          }
        }
      });
      return returntext
    }
  },
  companieEventsSettings(state) {
    if (state.companie.settings && state.companie.settings.events)
      return state.companie.settings.events
    else return {}
  },
  companieImagesSettings(state) {
    if (state.companie.settings && state.companie.settings.images)
      return state.companie.settings.images
    else return {}
  },
  getCompanieBranches(state) {
    if (state.companie.branchs) return state.companie.branchs
    return null
  },
  getCompanieBranchName: (state) => (id) => {
    // Retorna nome ou undefined
    let branch = id
      ? state.companie.branchs.find((branch) => branch.branch_id === id)
      : undefined
    return branch ? branch.branch_name : undefined
  },
  getPaymentName: (state) => (payment) => {
    // Retorna nome ou string -
    if (payment.name) return payment.name

    let pay = payment
      ? Object.values(state.companie.settings.payments).find(
          (paybd) => paybd.type === payment.type || paybd.code === payment.code
        )
      : undefined
    return pay ? pay.name : '-'
  },
  getCompanieBranchLocation: (state) => (id) => {
    const branch = state.companie.branchs.find(
      (branch) => branch.branch_id === id
    )
    if (branch) {
      return { lat: branch.latitude, lng: branch.longitude }
    }
    return null
  },
  getDriverName: (state, getters, rootState) => (id) => {
    // Retorna nome ou undefined
    if (id) {
      const driver = rootState.Drivers.allDrivers.find(
        (driverlist) => driverlist.auth_uid === id
      )
      return driver ? driver.name : ''
    }
    return undefined
  },
}
